import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';

function List() {
    const profileFilter = chooseProfileFilter();

    const pathFrontEnd = '/formscreenhelpconfigs/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpoint: config.endpoints.backend + 'formscreenhelpconfigs/getall',
        endpointDelete: config.endpoints.backend + 'formscreenhelpconfigs/delete',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall'
    }

    let list = {
        labelTitle: 'Lista de Configurações de Ajuda na Tela de Formulário',
        labelTitleButtonAdd: 'Incluir nova Configuração de Ajuda',
        fieldsShowOnDelete: ['functionality_name'],
        showPrintButtons: true,
        filter: {
            ...profileFilter
        },
        columns: [
            {
                name: 'functionality_name',
                label: 'Tela'
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
